import { motion } from "framer-motion";
import { useState } from "react";

const Contactme = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/buildwithpelumi@gmail.com",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (data.success === "true" || data.success === true) {
        setSubmitted(true);
        form.reset();

        setTimeout(() => {
          setSubmitted(false);
        }, 5000);
      } else {
        setError("Something went wrong. Try again.");
      }
    } catch (err) {
      setError("Failed to send message. Check your internet connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#171718] border-t border-white/10 pt-[140px] pb-[120px] overflow-hidden">
      <div className="mx-auto max-w-[1300px] px-6">
        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20 text-center"
        >
          <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-[#7C6AE6] mb-4 block">
            Contact
          </span>

          <h1 className="text-[36px] md:text-[62px] font-semibold uppercase text-white leading-[0.95]">
            Let’s build
            <br />
            <span className="text-white/30">
              something solid.
            </span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-white/55 max-w-2xl mx-auto leading-relaxed">
            Reach out directly or schedule a discovery call to talk about your
            project.
          </p>
        </motion.div>

        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* CONTACT FORM */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="rounded-[32px] border border-white/10 bg-white/[0.03] p-6 md:p-10"
          >
            <div className="mb-10">
              <p className="text-[#7C6AE6] text-[11px] uppercase tracking-[0.25em] mb-4">
                Contact Form
              </p>

              <h2 className="text-white text-[28px] md:text-[36px] font-semibold uppercase leading-none">
                Send a message
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* REQUIRED FOR FORMSUBMIT */}
              <input type="hidden" name="_captcha" value="false" />
              <input
                type="hidden"
                name="_subject"
                value="New Portfolio Contact Message"
              />

              {/* NAME */}
              <div>
                <label className="block text-[12px] uppercase tracking-[0.2em] text-white/40 mb-3">
                  Full Name
                </label>

                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Your Name"
                  className="
                    w-full
                    bg-black/20
                    border
                    border-white/10
                    rounded-2xl
                    px-5
                    py-4
                    text-white
                    placeholder:text-white/25
                    outline-none
                    focus:border-[#7C6AE6]
                    transition-colors
                  "
                />
              </div>

              {/* EMAIL */}
              <div>
                <label className="block text-[12px] uppercase tracking-[0.2em] text-white/40 mb-3">
                  Email Address
                </label>

                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your Email Address"
                  className="
                    w-full
                    bg-black/20
                    border
                    border-white/10
                    rounded-2xl
                    px-5
                    py-4
                    text-white
                    placeholder:text-white/25
                    outline-none
                    focus:border-[#7C6AE6]
                    transition-colors
                  "
                />
              </div>

              {/* PROJECT TYPE */}
              <div>
                <label className="block text-[12px] uppercase tracking-[0.2em] text-white/40 mb-3">
                  Project Type
                </label>

                <input
                  type="text"
                  name="project"
                  placeholder="Website, Redesign, Front-End Build..."
                  className="
                    w-full
                    bg-black/20
                    border
                    border-white/10
                    rounded-2xl
                    px-5
                    py-4
                    text-white
                    placeholder:text-white/25
                    outline-none
                    focus:border-[#7C6AE6]
                    transition-colors
                  "
                />
              </div>

              {/* MESSAGE */}
              <div>
                <label className="block text-[12px] uppercase tracking-[0.2em] text-white/40 mb-3">
                  Message
                </label>

                <textarea
                  name="message"
                  required
                  rows="7"
                  placeholder="Tell me about your project, timeline, goals, or what you need help with..."
                  className="
                    w-full
                    resize-none
                    bg-black/20
                    border
                    border-white/10
                    rounded-2xl
                    px-5
                    py-4
                    text-white
                    placeholder:text-white/25
                    outline-none
                    focus:border-[#7C6AE6]
                    transition-colors
                  "
                />
              </div>

              {/* BUTTON */}
              <div className="pt-2 flex flex-col items-start gap-4">
                <button
                  type="submit"
                  disabled={loading}
                  className="
                    inline-flex
                    items-center
                    justify-center
                    rounded-md
                    bg-[#7C6AE6]
                    px-8
                    py-4
                    text-sm
                    font-semibold
                    uppercase
                    tracking-wider
                    text-white
                    transition-all
                    duration-300
                    hover:bg-[#6d5bdd]
                    disabled:opacity-60
                    disabled:cursor-not-allowed
                  "
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>

                {submitted && (
                  <p className="text-green-400 text-sm">
                    Message sent successfully.
                  </p>
                )}

                {error && (
                  <p className="text-red-400 text-sm">
                    {error}
                  </p>
                )}
              </div>
            </form>
          </motion.div>

          {/* BOOK A CALL */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="
              rounded-[32px]
              border
              border-white/10
              bg-[#1B1B1D]
              overflow-hidden
              relative
            "
          >
        

            {/* TOP */}
            <div className="relative z-10 p-8 md:p-10 border-b border-white/10">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <p className="text-[#7C6AE6] text-[11px] uppercase tracking-[0.3em] font-bold mb-4">
                    Discovery Call
                  </p>

                  <h2 className="text-white text-[30px] md:text-[42px] font-semibold uppercase leading-[0.95]">
                    Book a call
                  </h2>
                </div>

                <div
                  className="
                    hidden
                    md:flex
                    w-14
                    h-14
                    rounded-full
                    border
                    border-white/10
                    items-center
                    justify-center
                    text-[#7C6AE6]
                    text-xl
                  "
                >
                  ↗
                </div>
              </div>

              <p className="text-white/55 leading-relaxed text-[15px] md:text-[17px] max-w-xl">
                Let’s talk through your project, goals, timelines, and how we
                can build something that actually works.
              </p>

              <div className="flex flex-wrap gap-3 mt-8">
                {[
                  "30 Min Call",
                  "Google Meet",
                  "Project Review",
                ].map((item) => (
                  <div
                    key={item}
                    className="
                      px-4
                      py-2
                      rounded-full
                      border
                      border-white/10
                      bg-white/[0.03]
                      text-white/70
                      text-[12px]
                      uppercase
                      tracking-wider
                    "
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* EMBED */}
            <div className="relative z-10 p-3 md:p-5 bg-[#171718]">
              <div
                className="
                  rounded-[24px]
                  overflow-hidden
                  border
                  border-white/10
                  bg-black
                "
              >
                <iframe
                  src="https://calendly.com/buildwithpelumi"
                  width="100%"
                  height="700"
                  frameBorder="0"
                  title="Calendly Booking"
                  className="bg-black"
                />
              </div>
            </div>
          </motion.div>
        </div>

        {/* FOOTER */}
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-24 text-center"
        >
          <p className="text-white/35 text-sm">
            Usually replies within a few hours.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Contactme;